import undoable, { excludeAction, groupByActionTypes } from "redux-undo";
import Helper from "../../functions/Helper.js";
import { createSlice } from "@reduxjs/toolkit";
import { getSelectionRect } from "../../functions/collisionChecking.js";
import { isEqual } from "lodash";
//function that creates all links from objects

const defaultHoops = (settings) => [
  {
    id: "object_-1",
    type: "object",
    subType: "hoop",
    team: null,
    pos: [0, 5.25],
    number: null,
    color: null,
    status: "NOT_SELECTED",
    displayOrder: 0,
  },
  {
    id: "object_-2",
    type: "object",
    subType: "hoop",
    team: null,
    pos: [0, settings?.editor?.court?.type === "HighSchool" ? 78.75 : 88.75],
    number: null,
    color: null,
    status: "NOT_SELECTED",
    displayOrder: 1,
  },
];

const emptyPhase = (settings) => ({
  objects: [...defaultHoops(settings)],
  note: null,
  links: [],
});

const defaultPhase = (settings) => ({
  id: 1,
  note: null,
  links: [],
  objects: [
    ...defaultHoops(settings),
    {
      id: "object_1",
      type: "object",
      subType: "player",
      team: "ball",
      pos: [0, 34],
      number: 1,
      color: Helper.defaultColor,
      status: "NOT_SELECTED",
      displayOrder: 6,
    },
    {
      id: "object_2",
      type: "object",
      subType: "player",
      team: "offense",
      pos: [-17, 28],
      number: 2,
      color: Helper.defaultColor,
      status: "NOT_SELECTED",
      displayOrder: 5,
    },
    {
      id: "object_3",
      type: "object",
      subType: "player",
      team: "offense",
      pos: [17, 28],
      number: 3,
      color: Helper.defaultColor,
      status: "NOT_SELECTED",
      displayOrder: 4,
    },
    {
      id: "object_4",
      type: "object",
      subType: "player",
      team: "offense",
      pos: [-11, 6],
      number: 4,
      color: Helper.defaultColor,
      status: "NOT_SELECTED",
      displayOrder: 3,
    },
    {
      id: "object_5",
      type: "object",
      subType: "player",
      team: "offense",
      pos: [11, 6],
      number: 5,
      color: Helper.defaultColor,
      status: "NOT_SELECTED",
      displayOrder: 2,
    },
  ],
});

const initialState = {
  activePhaseId: 1,
  phases: [defaultPhase()],
};

const phases = createSlice({
  name: "phases",
  initialState,
  reducers: {
    reset(state, action) {
      Helper.gaEvent("playcreator", "reset_play");
      return { activePhaseId: 1, phases: [defaultPhase(action.settings)] };
    },

    loadPhases(state, action) {
      return {
        activePhaseId: 1,
        ...action.payload.data.phases,
      };
    },
    /*
    saveNote(state, action) {
      let affectedPhase = Helper.getCurrentPhase(
        state.phases,
        action.payload.id
      );
      if (affectedPhase) {
        affectedPhase.note = convertToRaw(
          action.payload.note?.getCurrentContent()
        );
      }
    },*/
    changePhaseTitle(state, action) {
      let affectedPhase = Helper.getCurrentPhase(
        state.phases,
        action.payload.id
      );
      if (affectedPhase) {
        affectedPhase.title = action.payload.title;
      }
    },
    changeOverlay(state, action) {
      let affectedPhase = Helper.getCurrentPhase(
        state.phases,
        action.payload.id
      );
      if (affectedPhase) {
        affectedPhase.showOverlay = action.payload.value;
      }
    },
    changeOverlayDuration(state, action) {
      let affectedPhase = Helper.getCurrentPhase(
        state.phases,
        action.payload.id
      );
      if (affectedPhase) {
        affectedPhase.showOverlayDuration = action.payload.value;
      }
    },

    saveNoteQuill(state, action) {
      let affectedPhase = Helper.getCurrentPhase(
        state.phases,
        action.payload.id
      );
      if (affectedPhase) {
        affectedPhase.note = action.payload.note;
      }
    },
    deletePhase(state, action) {
      Helper.gaEvent("playcreator", "delete_phase");
      let newActiveId = state.activePhaseId;
      if (action.payload.id === state.activePhaseId) {
        let index = state.phases.findIndex((x) => x.id === action.payload.id);
        if (index + 1 === state.phases.length) {
          if (state.phases.length <= 1) {
            newActiveId = -1;
          } else {
            newActiveId = state.phases[index - 1].id;
          }
        } else {
          newActiveId = state.phases[index + 1].id;
        }
      }
      state.phases = state.phases.filter((x) => x.id !== action.payload.id);
      state.activePhaseId = newActiveId;
    },

    changePhase(state, action) {
      let currentPhase = Helper.getCurrentPhase(
        state.phases,
        state.activePhaseId
      );
      currentPhase.objects.forEach((item, i) => {
        item.status = "NOT_SELECTED";
      });
      state.activePhaseId = action.payload;
    },

    newPhase(state, action) {
      Helper.gaEvent("playcreator", "new_empty_phase");
      if (state.phases.length === 0) {
        state.activePhaseId = 1;
        state.phases = [defaultPhase(action.settings)];
      } else {
        let newId = Math.max(...state.phases.map((x) => x.id)) + 1;
        let indexOfActivePhaseId = state.phases.findIndex(
          (x) => x.id === state.activePhaseId
        );
        let currentPhase = Helper.getCurrentPhase(
          state.phases,
          state.activePhaseId
        );
        currentPhase.objects.forEach((item, i) => {
          item.status = "NOT_SELECTED";
        });
        state.phases.splice(indexOfActivePhaseId + 1, 0, {
          ...emptyPhase(action.settings),
          id: newId,
        });
        state.activePhaseId = newId;
      }
    },

    calculateNewPhase(state, action) {
      Helper.gaEvent("playcreator", "calculate_new_phase");
      let newId = Math.max(...state.phases.map((x) => x.id)) + 1;
      let indexOfActivePhaseId = state.phases.findIndex(
        (x) => x.id === state.activePhaseId
      );
      let currentPhase = Helper.getCurrentPhase(
        state.phases,
        state.activePhaseId
      );
      currentPhase.objects.forEach((item, i) => {
        item.status = "NOT_SELECTED";
      });

      state.phases.splice(indexOfActivePhaseId + 1, 0, {
        ...Helper.calculateNextPhase(currentPhase).nextState,
        id: newId,
        note: null,
        links: [],
        title: "",
      });
      state.activePhaseId = newId;
    },
    movePhase(state, action) {
      const [removed] = state.phases.splice(action.payload.lastId, 1);
      state.phases.splice(action.payload.nextId, 0, removed);
    },

    duplicatePhase(state, action) {
      Helper.gaEvent("playcreator", "duplicate_phase");
      let newId = Math.max(...state.phases.map((x) => x.id)) + 1;
      let indexOfActivePhaseId = state.phases.findIndex(
        (x) => x.id === state.activePhaseId
      );
      state.phases.splice(indexOfActivePhaseId + 1, 0, {
        ...state.phases[indexOfActivePhaseId],
        note: null,
        id: newId,
      });
      state.activePhaseId = newId;
    },

    deleteSelected(state, action) {
      Helper.gaEvent("playcreator", "delete_object");
      let currentPhase = Helper.getCurrentPhase(
        state.phases,
        state.activePhaseId
      );
      currentPhase.objects = Helper.resetDisplayOrder(
        currentPhase.objects.filter((x) => !Helper.checkIfSelected(x.status))
      );
      currentPhase.links = Helper.cleanLinks(
        currentPhase.links,
        currentPhase.objects
      );
    },

    tap(state, action) {
      let currentPhase = Helper.getCurrentPhase(
        state.phases,
        state.activePhaseId
      );
      let currentObjects = currentPhase.objects;

      let { id, ctrlKey = false } = action.payload;

      if (ctrlKey) {
        let selectedObjectsLength = currentObjects.filter(
          (x) => x.status === "SELECTED" || x.status === "SELECTED_MULTIPLE"
        ).length;

        let nextStatus =
          selectedObjectsLength > 0 ? "SELECTED_MULTIPLE" : "SELECTED";

        currentPhase.objects.forEach((item, i) => {
          if (
            id === item.id ||
            item.status === "SELECTED" ||
            (item.status === "SELECTED_MULTIPLE" && id !== item.id)
          ) {
            item.status = nextStatus;
          } else {
            item.status = "NOT_SELECTED";
          }
        });
      } else {
        currentObjects.forEach((item, i) => {
          item.status = "NOT_SELECTED";
        });
        let index = currentObjects.findIndex((x) => x.id === id);
        currentObjects[index] = {
          ...currentObjects[index],
          status: "SELECTED",
        };
      }
    },

    selectMultiple(state, action) {
      let nextStatus =
        action.payload.length > 1 ? "SELECTED_MULTIPLE" : "SELECTED";
      let currentPhase = Helper.getCurrentPhase(
        state.phases,
        state.activePhaseId
      );
      currentPhase.objects.forEach((item, i) => {
        if (action.payload.includes(item.id)) {
          item.status = nextStatus;
        } else {
          item.status = "NOT_SELECTED";
        }
      });
    },
    selectAll(state, action) {
      let currentPhase = Helper.getCurrentPhase(
        state.phases,
        state.activePhaseId
      );
      currentPhase.objects.forEach((item, i) => {
        item.status = item.subType === "hoop" ? item.status : "SELECTED";
      });
    },
    deleteMultiple(state, action) {
      let currentPhase = Helper.getCurrentPhase(
        state.phases,
        state.activePhaseId
      );
      currentPhase.objects = Helper.resetDisplayOrder(
        currentPhase.objects.filter((x) => {
          return !action.payload.map((y) => y.id).includes(x.id);
        })
      );
    },

    unselect(state, action) {
      let currentPhase = Helper.getCurrentPhase(
        state.phases,
        state.activePhaseId
      );
      currentPhase.objects.forEach((item, i) => {
        item.status = "NOT_SELECTED";
      });
    },

    bringToFront(state, action) {
      let currentPhase = Helper.getCurrentPhase(
        state.phases,
        state.activePhaseId
      );
      let currentDisplayOrder = currentPhase.objects.find(
        (x) => x.id === action.payload.id
      ).displayOrder;

      currentPhase.objects = Helper.reOrderObjects(currentPhase.objects, {
        source: currentDisplayOrder,
        destination: currentPhase.objects.length,
      });
    },

    sendToBack(state, action) {
      let currentPhase = Helper.getCurrentPhase(
        state.phases,
        state.activePhaseId
      );
      let currentDisplayOrder = currentPhase.objects.find(
        (x) => x.id === action.payload.id
      ).displayOrder;

      let minOrder = Math.min(
        ...currentPhase.objects
          .filter((x) => x.subType !== "hoop")
          .map((x) => x.displayOrder)
      );

      currentPhase.objects = Helper.reOrderObjects(currentPhase.objects, {
        source: currentDisplayOrder,
        destination: minOrder - 0.5,
      });
    },

    changeDisplayOrder(state, action) {
      let currentPhase = Helper.getCurrentPhase(
        state.phases,
        state.activePhaseId
      );
      //
      currentPhase.objects = Helper.reOrderObjects(
        currentPhase.objects,
        action.payload
      );
    },

    deleteObject(state, action) {
      Helper.gaEvent("playcreator", "delete_object");
      let currentPhase = Helper.getCurrentPhase(
        state.phases,
        state.activePhaseId
      );
      currentPhase.objects = Helper.resetDisplayOrder(
        currentPhase.objects.filter((x) => x.id !== action.payload.id)
      );
      currentPhase.links = Helper.cleanLinks(
        currentPhase.links,
        currentPhase.objects
      );
    },

    addObject(state, action) {
      let playerCircleRadius = Helper.getPlayerRadiusFromSettings(
        action.settings
      );

      let currentPhase = Helper.getCurrentPhase(
        state.phases,
        state.activePhaseId
      );

      let newObject = {
        ...Helper.roundObjectProperties(action.payload),
        id: Helper.nextObjectId(currentPhase.objects),
        displayOrder: Helper.nextObjectDisplayOrder(
          action.payload,
          currentPhase.objects
        ),
      };

      currentPhase.objects = Helper.reOrderAndAddObject(
        currentPhase.objects,
        newObject
      );

      let afterLinking = Helper.createLinksV2(
        currentPhase.objects,
        currentPhase.links,
        playerCircleRadius
      );

      Helper.addRotationToLinkedObjects(afterLinking, newObject, currentPhase);
      Helper.addColorToLinkedObjects(afterLinking, newObject, currentPhase);

      currentPhase.links = afterLinking.links;
      currentPhase.objects = afterLinking.objects;
    },

    addObjectByClick(state, action) {
      Helper.gaEvent("playcreator", "add_object");

      let currentPhase = Helper.getCurrentPhase(
        state.phases,
        state.activePhaseId
      );
      let points = {
        s: [-8, 40],
        m: [0, 40],
        e: [8, 40],
      };
      let selectedObject = Helper.selectedObject(currentPhase.objects);

      if (selectedObject && selectedObject.subType === "player") {
        let directionVector = Helper.normalizeVector([
          0 - selectedObject.pos[0],
          19 - selectedObject.pos[1],
        ]);
        points = {
          s: selectedObject.pos,
          m: Helper.roundCoords([
            selectedObject.pos[0] + (directionVector[0] * 8) / Math.sqrt(2),
            selectedObject.pos[1] + (directionVector[1] * 8) / Math.sqrt(2),
          ]),
          e: Helper.roundCoords([
            selectedObject.pos[0] + (16 / Math.sqrt(2)) * directionVector[0],
            selectedObject.pos[1] + (16 / Math.sqrt(2)) * directionVector[1],
          ]),
        };
      }
      if (selectedObject && selectedObject.type === "arrow") {
        let directionVector = Helper.normalizeVector([
          0 - selectedObject.e[0],
          19 - selectedObject.e[1],
        ]);
        points = {
          s: selectedObject.e,
          m: Helper.roundCoords([
            selectedObject.e[0] + (directionVector[0] * 8) / Math.sqrt(2),
            selectedObject.e[1] + (directionVector[1] * 8) / Math.sqrt(2),
          ]),
          e: Helper.roundCoords([
            selectedObject.e[0] + (16 / Math.sqrt(2)) * directionVector[0],
            selectedObject.e[1] + (16 / Math.sqrt(2)) * directionVector[1],
          ]),
        };
      }

      let addedProps =
        action?.payload?.type === "arrow" &&
        selectedObject &&
        selectedObject?.team === "defense_alt"
          ? {
              angle: selectedObject?.angle,
            }
          : {};

      let newObject = {
        ...action.payload,
        id: Helper.nextObjectId(currentPhase.objects),
        ...points,

        color:
          (selectedObject.subType === "player" ||
            selectedObject.type === "arrow") &&
          selectedObject.color
            ? selectedObject.color
            : Helper.defaultColor,
        status: "SELECTED",
        displayOrder: Helper.nextObjectDisplayOrder(
          action.payload,
          currentPhase.objects
        ),
        ...addedProps,
      };

      currentPhase.objects = Helper.reOrderAndAddObject(
        currentPhase.objects,
        newObject
      );

      if (
        (selectedObject.type === "arrow" ||
          selectedObject.subType === "player") &&
        action.payload.type === "arrow"
      ) {
        let newLink = {
          object: {
            id: newObject.id,
            subType: newObject.subType,
            type: newObject.type,
          },
          player: {
            id: selectedObject.id,
            subType: selectedObject.subType,
            type: selectedObject.type,
          },
          point: "s",
        };
        currentPhase.links = [...currentPhase.links, newLink];
      }
    },

    moveMultipleObjects(state, action) {
      let playerCircleRadius = Helper.getPlayerRadiusFromSettings(
        action.settings
      );

      let currentPhase = Helper.getCurrentPhase(
        state.phases,
        state.activePhaseId
      );
      let currentObjects = currentPhase.objects;

      action.payload.objects.forEach((object) => {
        let index = currentObjects.findIndex((x) => x.id === object.id);

        let changes = {};
        let keys = ["pos", "s", "m", "e", "h1", "h2"];

        keys.forEach((key) => {
          if (object[key]) {
            changes[key] = Helper.roundCoords([
              currentObjects[index][key][0] + action.payload.x,
              currentObjects[index][key][1] + action.payload.y,
            ]);
          }
        });

        if (currentObjects[index].points) {
          changes.points = currentObjects[index].points.map((point) => {
            return Helper.roundCoords([
              point[0] + action.payload.x,
              point[1] + action.payload.y,
            ]);
          });
        }

        currentObjects[index] = {
          ...currentObjects[index],
          ...changes,
        };
      });

      let afterLinking = Helper.createLinksV2(
        currentPhase.objects,
        currentPhase.links,
        playerCircleRadius
      );
      currentPhase.links = afterLinking.links;
      currentPhase.objects = afterLinking.objects;
    },

    moveSelectedObjects(state, action) {
      let playerCircleRadius = Helper.getPlayerRadiusFromSettings(
        action.settings
      );

      let currentPhase = Helper.getCurrentPhase(
        state.phases,
        state.activePhaseId
      );
      let currentObjects = currentPhase.objects;

      let selectedObjects = currentObjects.filter(
        (x) => x.status === "SELECTED" || x.status === "SELECTED_MULTIPLE"
      );

      let delta = action.payload.delta;

      //rounding deltas when its a singke object and a player or cone
      if (
        selectedObjects.length === 1 &&
        (selectedObjects[0].subType === "player" ||
          selectedObjects[0].subType === "cone")
      ) {
        if (delta.x > 0) {
          delta.x = Number.isInteger(selectedObjects[0].pos[0])
            ? delta.x
            : Math.floor(selectedObjects[0].pos[0]) -
              selectedObjects[0].pos[0] +
              delta.x;
        }
        if (delta.x < 0) {
          delta.x = Number.isInteger(selectedObjects[0].pos[0])
            ? delta.x
            : Math.ceil(selectedObjects[0].pos[0]) -
              selectedObjects[0].pos[0] +
              delta.x;
        }

        if (delta.y > 0) {
          delta.y = Number.isInteger(selectedObjects[0].pos[1])
            ? delta.y
            : Math.floor(selectedObjects[0].pos[1]) -
              selectedObjects[0].pos[1] +
              delta.y;
        }
        if (delta.y < 0) {
          delta.y = Number.isInteger(selectedObjects[0].pos[1])
            ? delta.y
            : Math.ceil(selectedObjects[0].pos[1]) -
              selectedObjects[0].pos[1] +
              delta.y;
        }
      }

      selectedObjects.forEach((object) => {
        let index = currentObjects.findIndex((x) => x.id === object.id);

        let changes = {};
        let keys = ["pos", "s", "m", "e", "h1", "h2"];

        keys.forEach((key) => {
          if (object[key]) {
            changes[key] = Helper.roundCoords([
              currentObjects[index][key][0] + delta.x,
              currentObjects[index][key][1] + delta.y,
            ]);
          }
        });

        currentObjects[index] = {
          ...currentObjects[index],
          ...changes,
        };
      });

      let afterLinking = Helper.createLinksV2(
        currentPhase.objects,
        currentPhase.links,
        playerCircleRadius
      );
      currentPhase.links = afterLinking.links;
      currentPhase.objects = afterLinking.objects;
    },

    changePolygonPointAmount(state, action) {
      let currentPhase = Helper.getCurrentPhase(
        state.phases,
        state.activePhaseId
      );
      let currentObjects = currentPhase.objects;

      let index = currentObjects.findIndex((x) => x.id === action.payload.id);

      let newPoints = Helper.createPoints(
        action.payload.pos,
        7,
        action.payload.amount
      );

      currentObjects[index] = {
        ...currentObjects[index],
        points: newPoints,
      };
    },

    moveObject(state, action) {
      let playerCircleRadius = Helper.getPlayerRadiusFromSettings(
        action.settings
      );
      let currentPhase = Helper.getCurrentPhase(
        state.phases,
        state.activePhaseId
      );
      let currentObjects = currentPhase.objects;

      currentObjects.forEach((x) => (x.status = "NOT_SELECTED"));
      let index = currentObjects.findIndex((x) => x.id === action.payload.id);

      currentObjects[index].status = "SELECTED";

      ["pos", "s", "m", "e", "h1", "h2"].forEach((key) => {
        if (currentObjects[index][key]) {
          currentObjects[index][key] = Helper.roundCoords(
            Helper.transposeCoord(
              action.payload.data[key],
              action.settings.editor.court,
              "SvgToCourt"
            )
          );
        }
      });

      let affectedLinks = currentPhase.links.filter(
        (link) => link.player.id === action.payload.id
      );

      if (
        affectedLinks.length > 0 &&
        (currentObjects[index].type === "object" ||
          currentObjects[index].type === "arrow")
      ) {
        affectedLinks.forEach((affectedLink) => {
          let indexOfAffectedArrow = currentPhase.objects.findIndex(
            (object) => object.id === affectedLink.object.id
          );
          let affectedArrow = currentPhase.objects[indexOfAffectedArrow];
          let oldArrow = Helper.onlyPoints(affectedArrow);
          let arrowChanges = Helper.transformArrow(
            oldArrow,
            {
              point: affectedLink.point,
              pos: Helper.transposeCoord(
                currentObjects[index].type === "object"
                  ? action.payload.data.pos
                  : action.payload.data.e,
                action.settings.editor.court,
                "SvgToCourt"
              ),
            },
            affectedArrow.shape
          );
          currentObjects[indexOfAffectedArrow] = {
            ...currentObjects[indexOfAffectedArrow],
            ...arrowChanges,
          };
        });
      }

      let afterLinking = Helper.createLinksV2(
        currentObjects,
        currentPhase.links,
        playerCircleRadius
      );
      currentPhase.links = afterLinking.links;
      currentPhase.objects = afterLinking.objects;
    },

    reorderObjects(state, action) {
      let currentPhase = Helper.getCurrentPhase(
        state.phases,
        state.activePhaseId
      );

      const isAction = (x) =>
        x.type === "arrow" ||
        x.subType === "handoff" ||
        x.subType === "text" ||
        x.subType === "rectangle" ||
        x.subType === "polygon" ||
        x.subType === "triangle" ||
        x.subType === "circle";

      let currentPhaseActions = currentPhase.objects.filter((x) => isAction(x));
      let currentPhaseNonActions = currentPhase.objects.filter(
        (x) => !isAction(x)
      );
      let [removed] = currentPhaseActions.splice(action.payload.oldIndex, 1);
      currentPhaseActions.splice(action.payload.newIndex, 0, removed);
      currentPhase.objects = [
        ...currentPhaseNonActions,
        ...currentPhaseActions,
      ];
    },

    editObject(state, action) {
      let currentPhase = Helper.getCurrentPhase(
        state.phases,
        state.activePhaseId
      );
      let currentObjects = currentPhase.objects;
      let index = currentObjects.findIndex(
        (x) => x.id === action.payload.actionId
      );
      currentObjects[index] = {
        ...currentObjects[index],
        ...Helper.roundObjectProperties(action.payload.changes),
      };
    },

    changeProperties(state, action) {
      let currentPhase = Helper.getCurrentPhase(
        state.phases,
        state.activePhaseId
      );
      let currentObjects = currentPhase.objects;
      let index = currentObjects.findIndex((x) => x.id === action.payload.id);
      currentObjects[index] = { ...currentObjects[index], ...action.payload };
    },

    editMultipleObjects(state, action) {
      let currentPhase = Helper.getCurrentPhase(
        state.phases,
        state.activePhaseId
      );
      let currentObjects = currentPhase.objects;
      action.payload.objects.forEach((object) => {
        let index = currentObjects.findIndex((x) => x.id === object.id);
        currentObjects[index] = {
          ...currentObjects[index],
          ...action.payload.changes,
        };
      });
    },

    doubleTap(state, action) {
      let currentPhase = Helper.getCurrentPhase(
        state.phases,
        state.activePhaseId
      );
      let currentObjects = currentPhase.objects;
      let index = currentObjects.findIndex((x) => x.id === action.payload.id);
      let currentObject = currentObjects[index];
      let newM = [
        (currentObject.s[0] + currentObject.e[0]) / 2,
        (currentObject.s[1] + currentObject.e[1]) / 2,
      ];
      currentObjects[index] = Helper.roundObjectProperties({
        ...currentObject,
        m: newM,
        h1: currentObject.h1
          ? [
              (currentObject.s[0] + newM[0]) / 2,
              (currentObject.s[1] + newM[1]) / 2,
            ]
          : undefined,
        h2: currentObject.h2
          ? [
              (newM[0] + currentObject.e[0]) / 2,
              (newM[1] + currentObject.e[1]) / 2,
            ]
          : undefined,
      });
    },

    animatorHoverEnter(state, action) {
      let nextStatus = "HOVERING_ANIMATOR";
      let currentPhase = Helper.getCurrentPhase(
        state.phases,
        state.activePhaseId
      );
      let currentObjects = currentPhase.objects;
      currentObjects.forEach((object) => {
        if (object.status === nextStatus) {
          object.status = "NOT_SELECTED";
        }
      });
      let currentObject = currentObjects.find(
        (x) => x.id === action.payload.id
      );

      currentObject.status = nextStatus;

      let onlyPlayers = currentObjects.filter((x) => x.subType === "player");

      let links = currentPhase.links.filter(
        (x) =>
          x.object.id === currentObject.id || x.player.id === currentObject.id
      );
      let startLinkedPlayer = Helper.getLinkedPlayer(
        links,
        currentObject,
        onlyPlayers,
        "s"
      );

      let endLinkedPlayer = Helper.getLinkedPlayer(
        links,
        currentObject,
        onlyPlayers,
        "e"
      );

      if (startLinkedPlayer) {
        startLinkedPlayer.status = nextStatus;
      }
      if (endLinkedPlayer) {
        endLinkedPlayer.status = nextStatus;
      }
    },

    animatorHoverLeave(state, action) {
      let currentPhase = Helper.getCurrentPhase(
        state.phases,
        state.activePhaseId
      );
      let currentObjects = currentPhase.objects;
      currentObjects.forEach((object) => {
        object.status = "NOT_SELECTED";
      });
    },

    mouseEnter(state, action) {
      let nextStatus = action.payload.status ?? "HOVERING";
      let currentPhase = Helper.getCurrentPhase(
        state.phases,
        state.activePhaseId
      );
      let currentObjects = currentPhase.objects;
      currentObjects.forEach((object) => {
        if (object.status === nextStatus) {
          object.status = "NOT_SELECTED";
        }
      });
      let index = currentObjects.findIndex((x) => x.id === action.payload.id);
      currentObjects[index] = { ...currentObjects[index], status: nextStatus };
    },

    mouseLeave(state, action) {
      let currentPhase = Helper.getCurrentPhase(
        state.phases,
        state.activePhaseId
      );
      let currentObjects = currentPhase.objects;
      let index = currentObjects.findIndex((x) => x.id === action.payload.id);
      currentObjects[index] = {
        ...currentObjects[index],
        status: "NOT_SELECTED",
      };
    },

    interactionStart(state, action) {
      let currentPhase = Helper.getCurrentPhase(
        state.phases,
        state.activePhaseId
      );

      if (action.payload.subType === "handoff") {
        currentPhase.links = currentPhase.links.filter(
          (link) => link.object.id !== action.payload.id
        );
      } else if (action.payload.subType !== "player") {
        currentPhase.links = currentPhase.links.filter(
          (link) =>
            (link.object.id !== action.payload.id &&
              link.player.id !== action.payload.id) ||
            (link.point !== action.payload.point &&
              action.payload.point !== "p")
        );
      }

      let currentObjects = currentPhase.objects;
      currentObjects.forEach((x) => (x.status = "NOT_SELECTED"));
      let index = currentObjects.findIndex((x) => x.id === action.payload.id);
      currentObjects[index] = {
        ...currentObjects[index],
        status: "INTERACTING",
      };
    },

    interactionStop(state, action) {
      let currentPhase = Helper.getCurrentPhase(
        state.phases,
        state.activePhaseId
      );
      let currentObjects = currentPhase.objects;
      let index = currentObjects.findIndex((x) => x.id === action.payload.id);
      currentObjects[index] = { ...currentObjects[index], status: "SELECTED" };
    },

    changeHoops(state, action) {
      let newHoops = Helper.hoops[action.payload];

      let enrichedNewHoops = newHoops.map((hoop, index) => ({
        id: "object_-" + (index + 1),
        type: "object",
        subType: "hoop",
        team: null,
        pos: hoop,
        number: null,
        color: null,
        status: "NOT_SELECTED",
      }));

      let newPhases = state.phases.map((phase) => {
        let newObjects = phase.objects.filter(
          (object) => object.subType !== "hoop"
        );
        newObjects = [...enrichedNewHoops, ...newObjects];

        return {
          ...phase,
          objects: newObjects,
        };
      });

      state.phases = newPhases;
    },
    changePlayerOfLink(state, action) {
      let currentPhase = Helper.getCurrentPhase(
        state.phases,
        state.activePhaseId
      );
      let currentObjects = currentPhase.objects;

      let newPlayer = currentObjects.find(
        (x) => x.id === action.payload.playerId
      );

      let linkIndex = currentPhase.links.findIndex((link) =>
        isEqual(link, action.payload.link)
      );

      if (linkIndex !== -1) {
        currentPhase.links[linkIndex] = {
          ...currentPhase.links[linkIndex],
          player: {
            id: newPlayer.id,
            subType: newPlayer.subType,
            type: newPlayer.type,
          },
        };
      }
    },
    mirrorSelected(state, action) {
      let currentPhase = Helper.getCurrentPhase(
        state.phases,
        state.activePhaseId
      );
      let currentObjects = currentPhase.objects;
      let selectedObjects = currentObjects.filter((object) =>
        Helper.checkIfSelected(object.status)
      );

      let affectedLinks = currentPhase.links.filter(
        (link) =>
          selectedObjects.some((object) => object.id === link.object.id) &&
          selectedObjects.some((object) => object.id === link.player.id)
      );

      let newObjects = selectedObjects.map((object) => {
        let newObject = { ...object };
        newObject.pos = object.pos && [
          -object.pos[0] -
            (["text", "rectangle"].includes(object.subType) ? object.width : 0),
          object.pos[1],
        ];
        newObject.s = object.s && [-object.s[0], object.s[1]];
        newObject.m = object.m && [-object.m[0], object.m[1]];
        newObject.e = object.e && [-object.e[0], object.e[1]];
        newObject.h1 = object.h1 && [-object.h1[0], object.h1[1]];
        newObject.h2 = object.h2 && [-object.h2[0], object.h2[1]];
        newObject.status = "NOT_SELECTED";
        return newObject;
      });

      let { objects: nextObjects, mapping } = Helper.replaceObjectIds(
        currentObjects,
        newObjects
      );

      let nextLinks = affectedLinks.map((link) => {
        let newLink = JSON.parse(JSON.stringify(link));
        newLink.object.id = mapping.find(
          (x) => x.oldId === link.object.id
        ).newId;
        newLink.player.id = mapping.find(
          (x) => x.oldId === link.player.id
        ).newId;
        return newLink;
      });

      currentPhase.links = [...currentPhase.links, ...nextLinks];
      currentPhase.objects = [...currentObjects, ...nextObjects];
    },

    flipSelectedXAxis(state, action) {
      let playerCircleRadius = Helper.getPlayerRadiusFromSettings(
        action.settings
      );
      let { objectSizes } = action.payload;

      let currentPhase = Helper.getCurrentPhase(
        state.phases,
        state.activePhaseId
      );
      let currentObjects = currentPhase.objects;
      let selectedObjects = currentObjects.filter((object) =>
        Helper.checkIfSelected(object.status)
      );

      let rect = getSelectionRect(selectedObjects, objectSizes, false, 1);

      selectedObjects.forEach((object) => {
        let index = currentObjects.findIndex((x) => x.id === object.id);

        currentObjects[index] = {
          ...currentObjects[index],
          pos: object.pos && [
            rect.x +
              rect.width -
              (object.pos[0] - rect.x) -
              (object.width ?? 0),
            object.pos[1],
          ],
          s: object.s && [
            rect.x + rect.width - (object.s[0] - rect.x),
            object.s[1],
          ],
          m: object.m && [
            rect.x + rect.width - (object.m[0] - rect.x),
            object.m[1],
          ],
          e: object.e && [
            rect.x + rect.width - (object.e[0] - rect.x),
            object.e[1],
          ],
          h1: object.h1 && [
            rect.x + rect.width - (object.h1[0] - rect.x),
            object.h1[1],
          ],
          h2: object.h2 && [
            rect.x + rect.width - (object.h2[0] - rect.x),
            object.h2[1],
          ],
        };
      });

      let afterLinking = Helper.createLinksV2(
        currentObjects,
        currentPhase.links,
        playerCircleRadius
      );
      currentPhase.links = afterLinking.links;
      currentPhase.objects = afterLinking.objects;
    },

    flipSelectedYAxis(state, action) {
      let playerCircleRadius = Helper.getPlayerRadiusFromSettings(
        action.settings
      );
      let { objectSizes } = action.payload;

      let currentPhase = Helper.getCurrentPhase(
        state.phases,
        state.activePhaseId
      );
      let currentObjects = currentPhase.objects;
      let selectedObjects = currentObjects.filter((object) =>
        Helper.checkIfSelected(object.status)
      );

      let rect = getSelectionRect(selectedObjects, objectSizes, false, 1);

      selectedObjects.forEach((object) => {
        let index = currentObjects.findIndex((x) => x.id === object.id);

        currentObjects[index] = {
          ...currentObjects[index],
          pos: object.pos && [
            object.pos[0],
            rect.y +
              rect.height -
              (object.pos[1] - rect.y) -
              (object.height ?? 0),
          ],
          s: object.s && [
            object.s[0],
            rect.y + rect.height - (object.s[1] - rect.y),
          ],
          m: object.m && [
            object.m[0],
            rect.y + rect.height - (object.m[1] - rect.y),
          ],
          e: object.e && [
            object.e[0],
            rect.y + rect.height - (object.e[1] - rect.y),
          ],

          h1: object.h1 && [
            object.h1[0],
            rect.y + rect.height - (object.h1[1] - rect.y),
          ],
          h2: object.h2 && [
            object.h2[0],
            rect.y + rect.height - (object.h2[1] - rect.y),
          ],
        };
      });
      let afterLinking = Helper.createLinksV2(
        currentObjects,
        currentPhase.links,
        playerCircleRadius
      );
      currentPhase.links = afterLinking.links;
      currentPhase.objects = afterLinking.objects;
    },

    fromClipboard(state, action) {
      let currentPhase = Helper.getCurrentPhase(
        state.phases,
        state.activePhaseId
      );

      let playerCircleRadius = Helper.getPlayerRadiusFromSettings(
        action.settings
      );

      let {
        objects,
        coordinates = false,
        objectSizes,
        fullCourt,
      } = action.payload;

      let newObjects = JSON.parse(JSON.stringify(objects));

      if (coordinates) {
        let rect = getSelectionRect(objects, objectSizes, fullCourt, 1);
        let delta = coordinates && [
          coordinates[0] - rect.x,
          coordinates[1] - rect.y,
        ];

        if (delta) {
          newObjects = newObjects.map((object) => {
            let changes = {};
            let keys = ["pos", "s", "m", "e", "h1", "h2"];

            keys.forEach((key) => {
              if (object[key]) {
                changes[key] = [
                  object[key][0] + (fullCourt ? -delta[1] : delta[0]),
                  object[key][1] + (fullCourt ? delta[0] : delta[1]),
                ];
              }
            });
            return { ...object, ...changes };
          });
        }
      }

      currentPhase.objects = [
        ...currentPhase.objects,
        ...Helper.replaceObjectIds(currentPhase.objects, newObjects).objects,
      ];

      let afterLinking = Helper.createLinksV2(
        currentPhase.objects,
        currentPhase.links,
        playerCircleRadius
      );
      currentPhase.links = afterLinking.links;
      currentPhase.objects = afterLinking.objects;
    },
  },
});

export const {
  changePolygonPointAmount,
  reset,
  loadPhases,
  //saveNote,
  saveNoteQuill,
  animatorHoverEnter,
  animatorHoverLeave,
  deletePhase,
  changePhase,
  newPhase,
  calculateNewPhase,
  movePhase,
  duplicatePhase,
  deleteSelected,
  tap,
  unselect,
  deleteObject,
  addObjectByClick,
  moveObject,
  moveMultipleObjects,
  moveObjectByArrows,
  reorderObjects,
  editObject,
  changeProperties,
  editMultipleObjects,
  doubleTap,
  mouseEnter,
  mouseLeave,
  interactionStart,
  changeHoops,
  changePhaseTitle,
  changeOverlay,
  fromClipboard,
  selectMultiple,
  deleteMultiple,
  addObject,
  moveSelectedObjects,
  mirrorSelected,
  flipSelectedXAxis,
  flipSelectedYAxis,
  selectAll,
  changeDisplayOrder,
  bringToFront,
  sendToBack,
  changePlayerOfLink,
  changeOverlayDuration,
} = phases.actions;

export const phasesReducer = phases.reducer;

export default undoable(phases.reducer, {
  ignoreInitialState: false,
  groupBy: groupByActionTypes([
    "phases/moveSelectedObjects",
    "phases/moveObject",
    "phases/editObject",
    "moveMultipleObjects",
    "moveObjectByArrows",
  ]),

  filter: excludeAction([
    "phases/tap",
    "phases/unselect",
    "phases/interactionStart",
    "phases/mouseLeave",
    "phases/mouseEnter",
    "phases/saveNoteQuill",
    "phases/doubleTap",
    "phases/selectMultiple",
    "phases/selectAll",
    "phases/animatorHoverEnter",
    "phases/animatorHoverLeave",
  ]),
});
